var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MovimentiMagazzino',{attrs:{"id_magazzino":_vm.id_magazzino,"id_articolo":_vm.id_articolo}})}
var staticRenderFns = []

export { render, staticRenderFns }